module.exports = __webpack_public_path__ + "static/media/ge-logo.5af1cec3.svg";